import { formAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/react'
import { INVOICE_FORM_INLINE_QUERY } from 'theme/containerQueries'

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
    formAnatomy.keys,
)

export const Form = defineMultiStyleConfig({
    variants: {
        invoice: definePartsStyle({
            container: {
                [INVOICE_FORM_INLINE_QUERY]: {
                    display: 'grid',
                    alignItems: 'center',
                    columnGap: 6,
                    gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1.85fr)',
                    '> label': { margin: 0 },
                    '> :not(label)': { minWidth: 0, gridColumn: 2 },
                },
            },
        }),
    },
})
